import { Client } from 'urql';
import { SearchLandingPageBySlugQuery } from './searchLandingPageQuery';
import { extractQueryAsParamsFromUrl } from '../../app-kit/helpers/urlHelpers';

export const fetchSearchLandingPage = async ({
  client,
  slug,
  toggleShowAvmData,
  toggleSuburbCTA,
}: {
  client: Client;
  slug: string;
  toggleShowAvmData: boolean;
  toggleSuburbCTA: boolean;
}) => {
  const propertyStatus = extractQueryAsParamsFromUrl(slug)?.propertyStatus;

  const showPrice = !(propertyStatus === 'OFF_MARKET' && !toggleShowAvmData);
  const { data, error } = await client
    .query(SearchLandingPageBySlugQuery, {
      slug,
      showPrice,
      imageFormatWebp: 'WEBP',
      toggleSuburbCTA,
    })
    .toPromise();
  return { data, error };
};
